export default class UiSelectors {
    static getAccountModalVisible = (state) => state.ui.modals.account || false;

    static getHelpModalVisible = (state) => state.ui.modals.help || false;

    static getTransactionModalVisible = (state) =>
        state.ui.modals.transaction || false;

    static getPricingModalVisible = (state) => state.ui.modals.pricing || false;

    static getCheckoutModalVisible = (state) =>
        state.ui.modals.checkout || false;

    static  getShoppingCartModalVisible = (state) =>
        state.ui.modals.shoppingcart || false;

    static getValidationModalVisible = (state) =>
        state.ui.modals.validation || false;

    static getFailedValidationModalVisible = (state) =>
        state.ui.modals.failedValidation || false;

    static getValidationFailureModalVisible = (state) =>
        state.ui.modals.validationFailed || false;

    static getValidationCancelModalVisible = (state) =>
        state.ui.modals.cancel || false;

    static getOrderCancelModalVisible = (state) =>
        state.ui.modals.cancel || false;

    static getLoginLookupModalVisible = (state) =>
        state.ui.modals.lookup || false;

    static getNewUserModalVisible = (state) => state.ui.modals.newUser || false;

    static getAppMounted = (state) => state.ui.appMounted;

    static getAccountModalPane = (state) => state.ui.accountModalPane;
}



// WEBPACK FOOTER //
// ./app/selectors/ui.js